const language = {
  networkRunning: {
    persian: "وضعیت پایدار",
    english: "Up and running!",
  },
  loading: {
    persian: "...در حال بارگذاری",
    english: "Loading...",
  },
  networkSlow: {
    persian: "شبکه کند است",
    english: "Network slow!",
  },
  networkVerySlow: {
    persian: "شبکه بسیار کند است",
    english: "Network very slow!",
  },
  networkDown: {
    persian: "شبکه خارج از دسترس است",
    english: "Network (or monitoring node) down!",
  },
  networkStatus: {
    persian: "وضعیت شبکه",
    english: "Network Status",
  },
  networkStatusLive: {
    persian: "وضعیت شبکه اصلی ققنوس",
    english: "Kuknos livenet Status",
  },
  networkStatusTest: {
    persian: " وضعیت شبکه تست ققنوس",
    english: "Network Status",
  },
  protocolVersion: {
    persian: "نسخه پروتکل",
    english: "Protocol version",
  },
  lastLedger: {
    persian: "آخرین لجر",
    english: "Last Ledger",
  },
  ledgerCloseTime: {
    persian: "بسته شده در",
    english: "Closed",
  },
  ledgerCloseTimeAgo: {
    persian: "گذشته در",
    english: "ago in",
  },
  ledgerCloseTimeSecond: {
    persian: "ثانیه",
    english: "s",
  },
  averageledgerCloseTime: {
    persian: "میانگین زمان بسته شدن لجرها در",
    english: "Average ledger close time in the last",
  },
  ledger: {
    persian: "لجر آخر",
    english: "ledgers",
  },
  ledgersCloseTimes: {
    persian: "زمان بسته شدن",
    english: "ledgers close times",
  },
  recentOperations: {
    persian: "عملیات اخیر",
    english: "RECENT OPERATIONS",
  },
  timeAgo: {
    persian: "زمان گذشته",
    english: "Time ago",
  },
  details: {
    persian: "جزئیات",
    english: "Details",
  },
  operation: {
    persian: "عملیات",
    english: "Operation",
  },
  source: {
    persian: "حساب",
    english: "Source",
  },
  successfulTx: {
    persian: "تراکنش ها",
    english: "SUCCESSFUL TX ",
  },
  successfulOp: {
    persian: "عملیات موفق",
    english: "Op",
  },

  last: {
    persian: "در",
    english: "in the last",
  },
  successfulTransactions: {
    persian: "تراکنش های موفق",
    english: "successful",
  },
  failedTransactions: {
    persian: "ناموفق",
    english: "Failed Tx",
  },
  operations: {
    persian: "عملیات",
    english: "‌OP",
  },
  transactions: {
    persian: "تراکنش ها",
    english: "TXs",
  },
  daysAgo: {
    persian: "۳۰ روز گذشته",
    english: "30 Days Ago",
  },
  amp: {
    persian: "و",
    english: "&",
  },
  last1: {
    persian: "زمان بسته شدن",
    english: "LAST",
  },
  closeTime: {
    persian: "",
    english: "CLOSE‌ TIME",
  },
  metricsInformation: {
    persian: "اطلاعات متریک شبکه",
    english: "Metrics Information",
  },

  paymonDist: {
    persian: "توزیع پیمان",
    english: "PAYMON DISTRIBUTION",
  },
  totalIssuedPaymon: {
    persian: "کل پیمان منتشر شده",
    english: "Total Issued Paymon",
  },
  totalDistributedPaymon: {
    persian: "کل پیمان توزیع شده",
    english: "TOTAL DISTRIBUTED PMN",
  },
  totalGold: {
    persian: "کل طلای موجود (برای مشاهده جزئیات کلیک کنید)",
    english: "TOTAL GOLD (CLICK FOR MORE DETAIL)",
  },
  founderTeamReserve: {
    persian: "مقدار ذخیره گروه موسس ققنوس",
    english: "FOUNDER TEAM RESERVE",
  },
  founderTeamDistributed: {
    persian: "مقدار توزیع شده گروه موسس ققنوس",
    english: "FOUNDER TEAM DISTRIBUTED",
  },
  newAnchorReserve: {
    persian: "مقدار ذخیره میزبان جدید",
    english: "NEW ANCHOR RESERVE",
  },
  newAnchorDistributed: {
    persian: "مقدار توزیع شده به میزبان جدید",
    english: "NEW ANCHOR DISTRIBUTED",
  },
  newUserReserve: {
    persian: "مقدار ذخیره کاربر پیشتاز",
    english: "NEW USER RESERVE",
  },
  newUserDistributed: {
    persian: "مقدار توزیع شده به کاربر پیشتاز",
    english: "NEW USER DISTRIBUTED",
  },
  monthlyDistributionReserve: {
    persian: "مقدار ذخیره عرضه ماهیانه",
    english: "MONTHLY DISTRIBUTION RESERVE",
  },
  monthlyDistributed: {
    persian: "مقدار توزیع شده برای عرضه ماهیانه",
    english: "MONTHLY DISTRIBUTED",
  },
  refundPmn: {
    persian: "مقدار پیمان بازخرید شده",
    english: "REFUND PMN",
  },

  metric: {
    persian: "متریک",
    english: "metric",
  },
  value: {
    persian: "ارزش",
    english: "value",
  },
  more: {
    persian: "بیشتر",
    english: "more",
  },
  less: {
    persian: "کمتر",
    english: "less",
  },
  status: {
    persian: "وضعیت",
    english: "Status:",
  },
  dashboard: {
    persian: "داشبورد",
    english: "dashboard:",
  },
  inflationProgress: {
    persian: "پیشرفت تورم",
    english: "inflation",
  },
  totalVote: {
    persian: "رتبه بندی تورم فعلی",
    english: "total vote",
  },
  payableInflation: {
    persian: "تورم قابل پرداخت",
    english: "payable inflation",
  },
  willTransferToNextWeek: {
    persian: "انتقال به هفته آینده",
    english: "Will transfer to next week",
  },
  percent: {
    persian: "رتبه بندی تورم فعلی",
    english: "percent",
  },
  willReceive: {
    persian: "دریافت",
    english: "will receive",
  },
  account: {
    persian: "حساب",
    english: "account",
  },
  votes: {
    persian: "آرا",
    english: "votes",
  },
  currentInflationRanking: {
    persian: "رتبه بندی تورم فعلی",
    english: "current Inflation Ranking",
  },
  currentInflation: {
    persian: "تورم فعلی",
    english: "current Inflation",
  },
  remainingTime: {
    persian: "زمان باقی مانده",
    english: "remaining time",
  },
  monthlyInflation: {
    persian: "تورم ماهانه",
    english: "monthly inflation",
  },
  feePool: {
    persian: "مخزن کارمزد",
    english: "fee pool",
  },
  lastMonthTransfer: {
    persian: "انتقال از ماه قبل",
    english: "last month transfer",
  },
  totalInflation: {
    persian: "تورم کل",
    english: "total inflation",
  },
  lastDistribution: {
    persian: "آخرین عرضه",
    english: "last distribution",
  },
  date: {
    persian: "تاریخ",
    english: "date",
  },
  totalPaid: {
    persian: "پرداخت کل",
    english: "total paid",
  },
  transferToNextMonth: {
    persian: "انتقال به ماه آینده",
    english: "transfer To Next Month",
  },
  featuredNodes: {
    persian: "گره های ویژه",
    english: "Featured nodes",
  },
  kuknostest: {
    persian: "شبکه تست ققنوس",
    english: "kuknos testnet",
  },
  kuknoslive: {
    persian: "شبکه اصلی ققنوس",
    english: "kuknos livenet",
  },
  KuknosNetwork: {
    persian: "داشبورد شبکه  ققنوس ",
    english: "kuknos Dashboard",
  },
  alphabeticalOrder: {
    persian: "مرتب سازی بر اساس حروف الفبا",
    english: "Alphabetical Order",
  },
  randomOrder: {
    persian: "مرتب سازی رندم",
    english: "Random Order",
  },
  backToDashboard: {
    persian: "بازگشت به داشبورد",
    english: "back to dashboard",
  },
  today: {
    persian: "امروز",
    english: "Today",
  },
  anchor: {
    persian: "میزبان",
    english: "Anchor",
  },
  distributedPmn: {
    persian: "پیمان توزیع شده",
    english: "Distributed PMN",
  },
  refundedPmn: {
    persian: "مقدار پیمان بازخرید شده",
    english: "Refunded PMN",
  },
  collateralGold: {
    persian: "طلای وثیقه",
    english: "Collateral Gold",
  },
  certificate: {
    persian: "گواهی",
    english: "Certificate",
  },
  liveCamera: {
    persian: "دوربین",
    english: "Live Camera",
  },
  totalCollateralGold: {
    persian: "کل طلای موجود",
    english: "Total Gold",
  },
  testNet: {
    persian: "شبکه تست",
    english: "Test Net",
  },
  mainNet: {
    persian: "شبکه اصلی",
    english: "Main Net",
  },
  kilogram: {
    persian: "کیلوگرم",
    english: "kilogram",
  },
  public: {
    persian: "آدرس حساب",
    english: "Public",
  },
  download: {
    persian: "دانلود",
    english: "download",
  },
  feeStateInLast5Ledgers: {
    persian: "وضعیت کارمزد در پنج دفتر کل آخر",
    english: "Fee stats (last 5 ledgers)",
  },
};
export default language;



// WEBPACK FOOTER //
// ./frontend/dictionary/index.js